import { Switch } from 'antd'
import { useState } from 'react'

import Dark0 from '@/assets/dark-btn-0.png'
import Dark1 from '@/assets/dark-btn-1.png'
import Light0 from '@/assets/light-btn-0.png'
import Light1 from '@/assets/light-btn-1.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { useMount } from '@/utils'

import { Container } from './ThemeSwitch.module'

const CloseOutlined = () => <img src={Light1} alt="darktheme" width={20} />

const CheckOutlined = () => <img src={Dark0} alt="lighttheme" width={20} />

export default function ThemeSwitch({ inSiderbar }: { inSiderbar: boolean }) {
  const [isDark, setIsDark] = useState(false)
  const { setTheme } = useLocalStorage()

  useMount(() => setIsDark(window.localStorage.theme === 'dark'))

  const handleToggleTheme = (checked: boolean) => {
    setIsDark(checked)
    if (checked) {
      setTheme('dark')
      document.documentElement.classList.add('dark')
      window.localStorage.theme = 'dark'
    } else {
      setTheme('light')
      document.documentElement.classList.remove('dark')
      window.localStorage.theme = ''
    }
  }

  return (
    <Container
      theme={isDark ? Dark1 : Light0}
      isDark={isDark}
      inSiderbar={inSiderbar}
    >
      <Switch
        className="bg-switchBtn-0 dark:bg-switchBtn-1"
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        checked={isDark}
        onClick={handleToggleTheme}
      />
    </Container>
  )
}
